import { Link } from "react-router-dom";

export function Landing() {
  return (
    <main
      className="flex min-h-screen flex-col items-center justify-center px-6 text-center"
      style={{ background: "#FFFCF8", color: "#1A1620" }}
    >
      <h1 className="font-display text-5xl md:text-6xl" style={{ color: "#8A4E9C" }}>
        Phlox is coming.
      </h1>
      <p className="mt-4 max-w-md text-base" style={{ color: "#9A8A78" }}>
        A quieter way to plan a home garden, with Sage helping you decide what to grow and when.
      </p>
      <div className="mt-10 flex w-full max-w-xs flex-col gap-3">
        <Link
          to="/signup"
          className="rounded-full px-5 py-3 text-base font-medium shadow-sm transition-opacity hover:opacity-90"
          style={{ background: "#8A4E9C", color: "#FFFFFF" }}
        >
          Get early access
        </Link>
        <Link
          to="/login"
          className="rounded-full px-5 py-3 text-base font-medium transition-colors"
          style={{
            background: "transparent",
            color: "#1A1620",
            border: "1px solid #EAE4DA",
          }}
        >
          I already have an account
        </Link>
      </div>
    </main>
  );
}
